<template>
  <v-card outlined>
    <table-search @search="v => (search = v)" />
    <v-data-table
      class="mt-5"
      dense
      fixed-header
      :headers="headers"
      :items="palletsStats"
      item-key="id"
      :items-per-page="15"
      :sort-by="['totalLoads']"
      :sort-desc="[true]"
      no-data-text="No Stats Found!"
      no-results-text="No Stats Found!"
      :search="search"
      :loading="pending"
      loading-text="Loading... Please wait"
    >
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import palletsStatsHeaders from '@/models/pallets-stats-headers';

export default {
  name: 'PalletStats',
  data() {
    return { search: '' };
  },
  computed: {
    ...mapState('dock', ['palletsStats', 'pending']),
    headers: () => palletsStatsHeaders
  }
};
</script>

<style lang="scss" scoped>
.table_search {
  width: 50%;
  @media (min-width: 340px) and (max-width: 767px) {
    width: 60%;
  }
}
</style>
